import { Component, Input, ViewEncapsulation, inject } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { IframeDialogComponent } from '@components';
import { BreakpointService } from 'src/app/@shared/services/breakpoint/breakpoint.service';
import { firstValueFrom } from 'rxjs';
import { isIframeable } from '@utils';
import { SafePipe } from '../../../../@shared/pipes/safe/safe.pipe';

@Component({
    selector: 'app-home-roadmaps-wysiwyg',
    templateUrl: './home-roadmaps-wysiwyg.component.html',
    styleUrls: ['./home-roadmaps-wysiwyg.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [SafePipe, MatDialogModule],
})
export class HomeRoadmapsWysiwygComponent {
    private dialog = inject(MatDialog);
    private breakpointService = inject(BreakpointService);

    @Input() roadmaps: string;

    /**
     * Clean and replace empty paragraph tags with no content such as empty spaces,
     * &nbps, etc...
     */
    get cleanedRoadmaps(): string {
        if (!this.roadmaps) return '';
        return this.roadmaps.replace(/<p>\s*(&nbsp;)?\s*<\/p>/gi, '');
    }

    /**
     * Intercepts clicks on links inside the roadmaps HTML content.
     * Opens iframeable URLs in a dialog, otherwise opens in a new tab.
     * @param event - the click event
     */
    handleLinkClick(event: MouseEvent): void {
        const target = event.target as HTMLElement;
        const anchor = target.closest('a') as HTMLAnchorElement;
        if (!anchor?.href) return;
        event.preventDefault();
        if (!isIframeable(anchor.href)) {
            window.open(anchor.href, '_blank');
            return;
        }
        firstValueFrom(this.breakpointService.mobile$).then((isMobile) => {
            this.dialog.open(IframeDialogComponent, {
                width: isMobile ? '' : '80%',
                maxWidth: BreakpointService.contentMaxWidth,
                height: isMobile ? '90%' : '80%',
                autoFocus: false,
                data: { src: anchor.href },
            });
        });
    }
}
